__turbopack_context__.v({
  "heading": "ServiceInformation-module-scss-module__j_3R6q__heading",
  "main": "ServiceInformation-module-scss-module__j_3R6q__main",
});
